export default __webpack_public_path__ + "emptyChatView.857b807739045911b8ce8d955476ae43.svg";